import { rules, validate, type schema } from "@/utils/validators";
import type { question, test } from "./types.api";

const questionSchema: schema<question> = {
    difficulty: [rules.required("Dificultad es requerida.")],
    thematic_area: [rules.required("Área temática es requerida.")],
    competence: [rules.required("Competencia es requerida.")],
    correct_answer: [rules.required("Respuesta es requerida.")],
};

export const validateTestConfig = (test: test): Record<number, Record<string, string>> => {
    const errors: Record<number, Record<string, string>> = {};

    test.questions.forEach((question, index) => {
        const questionErrors = validate(question, questionSchema);
        if (Object.keys(questionErrors).length > 0) {
            errors[index] = questionErrors;
        }
    });

    return errors;
};
